var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 71,
    viewBox: "0 0 43 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_3821_7267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.6844 40.4898H3.92773V8.42853H41.6606C42.8012 8.42853 43.4031 9.76017 42.6428 10.5983L30.976 23.5152C30.5324 24.0087 30.5324 24.7529 30.9681 25.2464L42.6586 38.32C43.419 39.1581 42.817 40.4898 41.6844 40.4898Z",
    fill: "#3E809D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.16003 71C2.2175 71 1.44922 70.2402 1.44922 69.308V3.12543H4.87876V69.3002C4.87876 70.2402 4.11048 71 3.16003 71Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.16025 6.25088C4.90561 6.25088 6.3205 4.85157 6.3205 3.12544C6.3205 1.39931 4.90561 0 3.16025 0C1.41489 0 0 1.39931 0 3.12544C0 4.85157 1.41489 6.25088 3.16025 6.25088Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.87875 40.8971H1.44921C1.37 40.8971 1.30664 40.8344 1.30664 40.7561V7.99769C1.30664 7.91935 1.37 7.85669 1.44921 7.85669H4.87875C4.95796 7.85669 5.02132 7.91935 5.02132 7.99769V40.7561C5.0134 40.8422 4.95796 40.8971 4.87875 40.8971Z",
    fill: "#3E809D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3821_7267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 71,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.e52a79ec937cca70ee64b2ab92055a99.svg";
export { ForwardRef as ReactComponent };